import React, { useContext , useEffect } from "react";
import styles from './Home.module.css';
import BrandCountrySelect from "../../brandCountrySelect/BrandCountrySelect";
import { useNavigate } from "react-router-dom";
import { BrandCountryContext } from "../../providers/BrandCountryProvider";
import HomeButton from "./HomeButtons";
import HiQHomeButton from "./HiQHomeButtons";

export default function HiQHome(){

    const {brand,setBrand,country,setCountry,language,setLanguage,disable,setDisable,handlePageChange} = useContext(BrandCountryContext);

    const navigate = useNavigate();

    const handleNavClick = (path) => {
        if(path === '!!!hiq/schemeRequest'){
            window.open('https://form.jotform.com/252604125036043','_blank');
        } else {
            window.scrollTo(0,0);
            navigate('/'+path);
        }
    }

    useEffect(() => {
        setDisable(false);
        handlePageChange(window.location.pathname);
    },[]);

    const guidelinesContent = [
        'Guidelines'
    ];
    const schemeRequestContent = [
        'External Scheme',
        'Internal Scheme',
        'Artwork pack'
    ];
    const logosContent = [
        'Furniture Catalogue'
    ];
    const marketingContent = [
        'Marketing Images',
        'Social Adverts',
        'Artwork',
        'In-store Digital Content'
    ];
    // 'Container Adverts',
    //     'Digital Adverts',
    //     'Digital Signage Adverts',
    //     'Print Adverts',
    //     'Web Adverts',
    const generalContent = [
        'Briefing Document',
        'Vehicle Livery Examples',
        'Store Portfolio'
    ];

    return(
        <div className={styles.container}>
            <div className={styles.buttonContainer2}>
                <HiQHomeButton gridColumn={'span 3'} gridRow="1/2" handleNavClick={handleNavClick} content={schemeRequestContent} pagePath={'hiq/schemeRequest'} name={'Scheme Request'} tagLine={'Site Submission Form'} />
                <HiQHomeButton gridColumn={'span 3'} gridRow="1/2" handleNavClick={handleNavClick} content={guidelinesContent} pagePath={'hiq/guidelines'} name={'Guidelines'} tagLine={'Brand Rules & Standards'} />
                <HiQHomeButton gridColumn={'span 2'} gridRow="2/3" handleNavClick={handleNavClick} content={generalContent} pagePath={'hiq/implementation'} name={'Implementation'} tagLine={'Briefing & Implementation Examples'} />
                <HiQHomeButton gridColumn={'span 2'} gridRow="2/3" handleNavClick={handleNavClick} content={logosContent} pagePath={'hiq/catalogue'} name={'Furniture Catalogue'} tagLine={'Furniture & Signage'} />
                <HiQHomeButton gridColumn={'span 2'} gridRow="2/3" handleNavClick={handleNavClick} content={marketingContent} pagePath={'hiq/marketingAssets'} name={'Marketing Assets'} tagLine={'Web & Print Adverts'} />
                {/* <HiQHomeButton gridColumn={'span 2'} handleNavClick={handleNavClick} content={logosContent} pagePath={'hiq/businessCardGen'} name={'Business Cards'} tagLine={'Card Design Generator'} /> */}
            </div>
        </div>
    )
}